import React from 'react';

const AuthorizedComponent = (props) => {
    const { children } = props;
    return (
        <>
            { children }
        </>
    );
};
export default AuthorizedComponent;